export const MIN_TEXT_WORDS = 10;
export const MIN_TEXT_LETTERS = 10;
export const MIN_EOD_WORDS = 5;

export const countWords = (value = "") => (
    String(value)
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .length
);

export const getMinimumWordsError = (value, label, minimum = MIN_TEXT_WORDS) => {
    const words = countWords(value);
    if (words >= minimum) return "";
    return `${label} must be at least ${minimum} words. Current: ${words}.`;
};


export const getRequiredMinimumWordsError = (value, label, minimum = MIN_EOD_WORDS) => {
    const words = countWords(value);
    if (words === 0) return `${label} is required.`;
    return getMinimumWordsError(value, label, minimum);
};

export const countLetters = (value = "") => (
    String(value)
        .trim()
        .length
);

export const getMinimumLettersError = (value, label, minimum = MIN_TEXT_LETTERS) => {
    const letters = countLetters(value);
    if (letters >= minimum) return "";
    return `${label} must be at least ${minimum} letters. Current: ${letters}.`;
};

